import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import update from 'immutability-helper';
// components
import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import DatePicker from '../Common/DatePicker';
import Form from '../Common/Form.react';
import MenuItem from 'material-ui/MenuItem';
import SelectField from '../Common/SelectField';
import TextField from '../Common/TextField';
import { Card, CardText } from 'material-ui/Card';
import CategorySelector from '../Category/CategorySelector';
import SkillChip from "../Skill/SkillChip";
import SelectSkill from "../Skill/SelectSkill";
// business logic
import CourseActions from '../../actions/CourseActionCreator';
import CourseStore from '../../stores/CourseStore';
import ThemeActions from '../../actions/ThemeActionCreator';
import ThemeStore from '../../stores/ThemeStore';
import EmailTemplateActions from '../../actions/EmailTemplateActionCreator';
import EmailTemplateStore from '../../stores/EmailTemplateStore';
import VendorActions from '../../actions/VendorActionCreator';
import VendorStore from '../../stores/VendorStore';

// constants
const url = '/dashboard/courses';

const menuById = ({id, name})  => <MenuItem key={id} value={id} primaryText={name} />;
const menuByName = ({id, name}) => <MenuItem key={id} value={name} primaryText={name} />;
const validations = {
    code: {
        rules: {
            maxLength: 16,
            matchRegexp: /^\S*$/
        },
        errors: {
            maxLength: 'Maximum length of 16 characters',
            matchRegexp: 'The code cannot contain spaces'
        }
    }
};

const styles = {
    floatingLabelStyle: {
        color: 'rgba(117, 117, 117, .50)'
    }
};

const CourseForm = React.createClass({


    getInitialState: function() {

        const validFrom = new Date();
        return {

            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),
            details: {
                id: '',
                name: '',
                description: '',
                overview: '',
                capacity: '',
                version:'',
                code: '',
                duration: '',
                url: '',
                courseSurveyUrl: '',
                cost: '',
                price: '',
                type: 'classroom',
                status: 'active',
                theme: 'default',
                visibility: 'private',
                validFrom: validFrom,
                validTo: null,
                skillId: '',
                skillName: '',
                skillCode: '',
                sendEmail: true,
                emailTemplate: '',
                emailTemplateId: '',
                vendor: '',
                vendorId: '',
                accessGroup: '',
                accessGroupId: null,
                automaticCourseCompletion: true
            },
            typeOptions: [],
            statusOptions: [],
            themeOptions: [],
            visibilityOptions: ['private', 'public'],
            emailTemplateOptions: [],
            categoryId: null,
            accessGroups: [],
            skill: null,
            vendors: []
        };
    },

    componentWillMount: function() {
        CourseStore.addChangeListener(this._onCourseChange);
        CourseActions.getSimplifiedStatusList();
        CourseActions.getTypeOptions();

        ThemeStore.addChangeListener(this._onThemeChange);
        ThemeActions.getAll();

        if (this.state.isEdit) {
            CourseActions.getById(this.props.routeParams.id);
        }

        EmailTemplateStore.addChangeListener(this._onEmailTemplateChange);
        EmailTemplateActions.getAll();

        VendorStore.addChangeListener(this._onVendorChange);
        VendorActions.getAll();
    },

    componentWillUnmount: function() {
        CourseStore.removeChangeListener(this._onCourseChange);
        ThemeStore.removeChangeListener(this._onThemeChange);
        EmailTemplateStore.removeChangeListener(this._onEmailTemplateChange);
        VendorStore.removeChangeListener(this._onVendorChange);
    },

    

    render: function() {

        const formTitle = (this.state.isEdit ? this.state.details.name : 'New course');
        const redirectTo = (this.state.isEdit ? `/dashboard/course/${this.state.details.id}/settings` : url);

        let accessGroups;
        if (!!this.context.auth.identity && !!this.context.auth.identity.accessGroups && 0 < this.context.auth.identity.accessGroups.length) {
            accessGroups = this.context.auth.identity.accessGroups.map(menuById);
        } else {
            accessGroups = [menuById({key: this.state.details.accessGroupId, name: this.state.details.accessGroup})];
        }

        return (
            <Form
                onSave={this._onSave}
                onCancel={this._onCancel}
                title={formTitle}
                redirectTo={redirectTo}
            >
                <Card className="cent-card">
                    <CardText>
                <div className='cent-flex-row'>
                    <div className='cent-col-1'>
                        <TextField
                            name="name"
                            value={this.state.details.name}
                            validations="minLength:8,maxLength:80"
                            validationError="Please use only numbers and letters, at least 8"
                            hintText="Name"
                            floatingLabelText="Name"
                            floatingLabelFixed={true}
                            floatingLabelStyle={styles.floatingLabelStyle}
                            required
                        />
                    </div>
                    <div className='cent-col-1'>
                        <TextField
                            name="description"
                            value={this.state.details.description}
                            multiLine={true}
                            rowsMax={8}
                            hintText="Description"
                            floatingLabelText="Description"
                            floatingLabelFixed={true}
                            floatingLabelStyle={styles.floatingLabelStyle}
                        />
                    </div>
                    <div className='cent-col-1'>
                        <TextField
                            name="overview"
                            value={this.state.details.overview}
                            multiLine={true}
                            rowsMax={8}
                            hintText="Overview"
                            floatingLabelText="Overview"
                            floatingLabelFixed={true}
                            floatingLabelStyle={styles.floatingLabelStyle}
                        />
                    </div>
                    <div className='cent-col-1'>
                        <TextField
                            name="url"
                            value={this.state.details.url}
                            validations="maxLength:250,isUrl"
                            validationError="Please enter a valid URL"
                            hintText="URL"
                            floatingLabelText="URL"
                            floatingLabelStyle={styles.floatingLabelStyle}
                        />
                    </div>
                    <div className='cent-col-1'>
                        <TextField
                            name="courseSurveyUrl"
                            value={this.state.details.courseSurveyUrl}
                            validations="maxLength:250,isUrl"
                            validationError="Please enter a valid URL"
                            hintText="Course Survey URL"
                            floatingLabelText="Course Survey URL"
                            floatingLabelStyle={styles.floatingLabelStyle}
                        />
                    </div>
                    <div className='cent-col-2'>
                        <DatePicker
                            name='validFrom'
                            value={this.state.details.validFrom}
                            maxDate={this.state.details.validTo}
                            hintText="Available from"
                            floatingLabelText="Available from"
                            floatingLabelStyle={styles.floatingLabelStyle}
                            onChange={this._onValidFromChange}
                            required
                        />
                    </div>
                    <div className='cent-col-2'>
                        <DatePicker
                            name='validTo'
                            value={this.state.details.validTo}
                            minDate={this.state.details.validFrom}
                            hintText="Available to"
                            floatingLabelText="Available to"
                            floatingLabelStyle={styles.floatingLabelStyle}
                            onChange={this.onValidToChange}
                        />
                    </div>
                </div>

                <h2>Classification</h2>
                <div className='cent-flex-row'>
                    <div className='cent-col-1'>
                        <SelectField
                            name="type"
                            value={this.state.details.type}
                            hintText="Type"
                            floatingLabelText="Type"
                            floatingLabelFixed={true}
                            floatingLabelStyle={styles.floatingLabelStyle}
                            autoWidth={true}
                            required
                        >
                            {this.state.typeOptions}
                        </SelectField>
                    </div>
                    <div className='cent-col-1'>
                        <CategorySelector
                            onConfirmSelection={(categoryId) => this.setState({categoryId})}
                            options={{canAddContent: true, limit: 0}}
                            defaultCategoryId={!!this.state.isEdit ? this.state.details.categoryId : null}
                        />
                    </div>
                </div>
                <div className='cent-flex-row'>
                    <div className='cent-col-2'>
                        <TextField
                            name="code"
                            value={this.state.details.code}
                            validations={validations.code.rules}
                            validationErrors={validations.code.errors}
                            hintText="Code"
                            floatingLabelText="Code"
                            floatingLabelStyle={styles.floatingLabelStyle}
                            required
                        />
                    </div>
                    <div className='cent-col-2'>
                        <TextField
                            name="version"
                            value={this.state.details.version}
                            validations="isNumeric"
                            validationError="Numbers only"
                            hintText="Version"
                            floatingLabelText="Version"
                            floatingLabelStyle={styles.floatingLabelStyle}
                        />
                    </div>
                </div>

                <h2>Training</h2>
                <div className='cent-flex-row'>
                    <div className='cent-col-1'>
                        {!this.state.skill
                            ? <SelectSkill onSelect={(name, id) => this.setState({skill: {id, name}})}/>
                            : <div>
                                <div className="cent-checkbox-hint">Skill</div>
                                <SkillChip skill={this.state.skill} onDelete={() => this.setState({skill: null})}/>
                            </div>
                        }
                    </div>

                    <div className='cent-col-2'>
                        <TextField
                            name="duration"
                            value={this.state.details.duration}
                            validations="isNumeric"
                            validationError="Duration in minutes"
                            hintText="Duration (mins)"
                            floatingLabelText="Duration"
                            floatingLabelStyle={styles.floatingLabelStyle}
                        />
                    </div>
                    <div className='cent-col-2'>
                        {/*<TextField*/}
                            {/*name="capacity"*/}
                            {/*value={this.state.details.capacity}*/}
                            {/*validations="maxLength:4,isInt"*/}
                            {/*validationError="Use only numbers (max 9999)"*/}
                            {/*hintText="Capacity"*/}
                            {/*floatingLabelText="Capacity"*/}
                            {/*floatingLabelStyle={styles.floatingLabelStyle}*/}
                        {/*/>*/}
                    </div>

                    <div className='cent-col-1'>
                        <div className='cent-checkbox-wrapper'>
                            <div className='cent-checkbox-hint'>Automatically set the course to Complete when a user completes all required modules</div>
                            <Checkbox
                                name="automaticCourseCompletion"
                                value={this.state.details.automaticCourseCompletion}
                                label="Autocomplete"
                            />
                        </div>
                    </div>
                </div>

                <h2>Notifications</h2>
                <div className='cent-flex-row'>
                    <div className='cent-col-1'>
                        <div className='cent-checkbox-wrapper'>
                            <div className='cent-checkbox-hint'>Email notifications (enrolment, completion, cancel, delete)</div>
                            <Checkbox
                                name="sendEmail"
                                value={this.state.details.sendEmail}
                                label="Enabled"
                            />
                        </div>
                    </div>
                    <div className='cent-col-1'>
                        <div className='cent-checkbox-wrapper'>
                            <Checkbox
                                name="sendJoiningInstructions"
                                value={this.state.details.sendJoiningInstructions}
                                label="Send joining instructions"
                            />
                        </div>
                    </div>
                    <div className='cent-col-1'>
                        <div className='cent-checkbox-wrapper'>
                            <Checkbox
                                name="sendCreatorNotifications"
                                value={this.state.details.sendCreatorNotifications}
                                label="Send admin notifications"
                            />
                        </div>
                    </div>
                    <div className='cent-col-1'>
                        <SelectField
                            name="emailTemplateId"
                            value={this.state.details.emailTemplateId}
                            hintText="Email template"
                            floatingLabelText="Notification template"
                            floatingLabelFixed={true}
                            floatingLabelStyle={styles.floatingLabelStyle}
                            autoWidth={true}
                        >
                            <MenuItem key="root" value={0} primaryText="(Default)" />
                            {this.state.emailTemplateOptions}
                        </SelectField>
                    </div>
                </div>
                <h2>Display</h2>
                <div className='cent-flex-row'>
                    <div className='cent-col-1'>
                        <SelectField
                            name="accessGroupId"
                            value={this.state.details.accessGroupId}
                            floatingLabelText="Scope"
                            floatingLabelFixed={true}
                            floatingLabelStyle={styles.floatingLabelStyle}
                            autoWidth={true}
                            hintText="Hint text"
                            required
                        >
                            {accessGroups}
                        </SelectField>
                    </div>
                    <div className='cent-col-2'>
                        <SelectField
                            name="visibility"
                            value={this.state.details.visibility}
                            hintText="Visibility"
                            floatingLabelText="Visibility"
                            floatingLabelFixed={true}
                            floatingLabelStyle={styles.floatingLabelStyle}
                            autoWidth={true}
                            required
                        >
                            {this.state.visibilityOptions.map(function(vis) {
                                return <MenuItem key={vis} value={vis} primaryText={vis} />;
                            })}
                        </SelectField>
                    </div>
                    <div className='cent-col-2'>
                        <SelectField
                            name="status"
                            value={this.state.details.status}
                            floatingLabelText="Status"
                            floatingLabelFixed={true}
                            floatingLabelStyle={styles.floatingLabelStyle}
                            autoWidth={true}
                            required
                        >
                            {this.state.statusOptions}
                        </SelectField>
                    </div>
                    <div className='cent-col-1'>
                        <SelectField
                            name="theme"
                            value={this.state.details.theme}
                            floatingLabelText="Theme"
                            floatingLabelFixed={true}
                            floatingLabelStyle={styles.floatingLabelStyle}
                            autoWidth={true}
                            required
                        >
                            {this.state.themeOptions}
                        </SelectField>
                    </div>
                </div>
                <h2>Finance</h2>
                <div className='cent-flex-row'>
                    <div className='cent-col-1'>
                        <SelectField
                            name="vendorId"
                            value={this.state.details.vendorId}
                            floatingLabelText="Vendor"
                            floatingLabelFixed={true}
                            floatingLabelStyle={styles.floatingLabelStyle}
                            autoWidth={true}
                        >
                            <MenuItem key="root" value={0} primaryText="(None)" />
                            {this.state.vendors}
                        </SelectField>
                    </div>
                    <div className='cent-col-2'>
                        <TextField
                            name="cost"
                            value={this.state.details.cost}
                            validations="maxLength:7,isNumeric"
                            validationError="Use only numbers (max 9999.99)"
                            hintText="Cost"
                            floatingLabelText="Cost"
                            floatingLabelStyle={styles.floatingLabelStyle}
                        />
                    </div>
                    <div className='cent-col-2'>
                        <TextField
                            name="price"
                            value={this.state.details.price}
                            validations="maxLength:7,isNumeric"
                            validationError="Use only numbers (max 9999.99)"
                            hintText="Price"
                            floatingLabelText="Price"
                            floatingLabelStyle={styles.floatingLabelStyle}
                        />
                    </div>
                </div>
                    </CardText>
                </Card>
            </Form>
        );
    },

    _onCancel: function() {
        document.location.href = (this.state.isEdit ? `/dashboard/course/${this.state.details.id}` : url);
    },

    _onSave: function(data) {
        data.categoryId = this.state.categoryId || this.state.details.categoryId;
        data.skill = !!this.state.skill && this.state.skill.id || null;

        if (this.state.isEdit) {
            return CourseActions.update(this.props.routeParams.id, data);
        } else {
            return CourseActions.save(data);
        }
    },

    _onCourseChange: function() {
        let state = {...this.state};
        if(this.state.isEdit) {
            let details = CourseStore.getById(this.props.routeParams.id);
            if (details !== undefined) {
                details.categoryId = details.categoryId || 0;
                details.vendorId = details.vendorId || 0;
                details.accessGroupId = details.accessGroupId || 0;
                details.emailTemplateId = details.emailTemplateId || 0;
                state.details = details;
                if (!!details.skillId) {
                    state.skill = {id: details.skillId, name: details.skillName};
                }
            }
        } else {
            state.details.categoryId = 0;
            state.details.vendorId = 0;
            state.details.accessGroupId = 0;
            state.details.emailTemplateId = 0;
        }
        const statuses = CourseStore.getStatusOptions();
        if (statuses !== undefined) {
            state = assign(state, {statusOptions: statuses.map(({name, label}) => <MenuItem key={name} value={name} primaryText={label}/>)});
        }
        const types = CourseStore.getTypeOptions();
        if (types !== undefined) {
            state = assign(state, {typeOptions: types.map(menuByName)});
        }

        this.setState(state);
    },

    _onEmailTemplateChange: function() {
        const emailTemplates = EmailTemplateStore.getByType('course_joining_instructions');
        if (emailTemplates !== undefined) {
            const emailTemplateOptions = emailTemplates.map(menuById);
            this.setState({emailTemplateOptions});
        }
    },

    _onThemeChange: function() {
        const themes = ThemeStore.getAll();
        if (!!themes) {
            this.setState({themeOptions: themes.map(({id, name}) => <MenuItem key={id} value={name} primaryText={name} />)});
        }
    },

    _onValidFromChange: function(e, value) {
        const details = update(this.state.details, { validFrom: { $set: value && new Date(value) } });
        this.setState({details});
    },

    onValidToChange: function(e, value) {
        const details = update(this.state.details, { validTo: { $set: value && new Date(value) } });
        this.setState({details});
    },

    _onVendorChange: function() {
        const vendors = VendorStore.getAll();
        if (vendors !== undefined) {
            const vendorOptions = vendors.map(menuById);
            this.setState({vendors: vendorOptions});
        }
    },

});

CourseForm.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default CourseForm;
